import React from "react";
import { motion } from "framer-motion";
import { Users, Timer, Store, TrendingUp } from "lucide-react";

const stats = [
  { icon: Store, label: "Businesses onboarded", value: "5,200+" },
  { icon: Timer, label: "Avg. setup time", value: "2 days" },
  { icon: Users, label: "Orders processed", value: "2 Cr+" },
  { icon: TrendingUp, label: "Revenue lift", value: "3.2×" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative py-16 border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, delay: i * 0.07 }}
            data-testid={`stat-${i}`}
            className="flex items-start gap-4"
          >
            <div className="w-11 h-11 rounded-xl glass flex items-center justify-center shrink-0">
              <s.icon className="w-5 h-5 text-violet-300" />
            </div>
            <div>
              <p className="font-display text-2xl sm:text-3xl font-bold text-gradient">{s.value}</p>
              <p className="text-xs sm:text-sm text-slate-500 mt-1">{s.label}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
